import React, {FC} from 'react';
import {ReactComponent as CopyLinkSmallSvg} from 'resources/icons/copy_link_small.svg';
import {ReactComponent as CopyLinkSmallDisabledSvg} from 'resources/icons/copy_link_small_disabled.svg';
import {makeStyles} from '@material-ui/core';
import {IWithDisabled} from 'models';

type ICopyLinkSmallOrangeIconProps = IWithDisabled;

export const CopyLinkSmallOrangeIcon: FC<ICopyLinkSmallOrangeIconProps> = ({disabled = false}) => {
  const classes = useStyles();
  return (
    <div className={classes.iconContainer}>
      {disabled ? <CopyLinkSmallDisabledSvg /> : <CopyLinkSmallSvg className={classes.orangeIcon} />}
    </div>
  );
};

const useStyles = makeStyles(() => ({
  iconContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '32px',
    width: '32px',
  },
  orangeIcon: {
    color: '#FF7700', // More vibrant orange
    filter: 'drop-shadow(0 2px 4px rgba(255, 119, 0, 0.6)) brightness(1.1)',
    fontWeight: 'bold',
    fontSize: '24px',
    width: '24px',
    height: '24px',
  },
}));
